var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"photography-content"},[_c('div',{staticClass:"photography-banner-image",style:({ backgroundImage: `url(${_vm.photographyBannerImageSrc})` })}),_c('div',{staticClass:"photography-overlay-image"},[_c('h1',{staticClass:"photography-banner-title"},[_vm._v(_vm._s(_vm.photographyBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }